import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { AddOrderInstructionLineModalLineFragmentDoc } from './AddOrderInstructionModalLine.generated'
import { AdvancedRequisitionLineModalLineFragmentDoc } from './AdvancedRequisitionLineModalLine.generated'
import * as Types from './purchasePlus_graphql'

export const RequisitionLineOptionsLineFragmentDoc = gql`
  fragment RequisitionLineOptionsLine on RequisitionLine {
    id
    uuid
    unitPrice
    taxPercentage
    unitTax
    ...AddOrderInstructionLineModalLine
    ...AdvancedRequisitionLineModalLine
  }
  ${AddOrderInstructionLineModalLineFragmentDoc}
  ${AdvancedRequisitionLineModalLineFragmentDoc}
` as unknown as DocumentNode<Types.RequisitionLineOptionsLineFragment, unknown>
